import React from 'react'

import './Horizontal.css'
import { Col, Row } from 'react-bootstrap'
import imgHANSAFLEX_Ireland_horizontal_homepage from '../../assets/Home/HANSAFLEX_Ireland_horizontal_homepage.webp'
const Horizontal = () => {
    return (
        <div className="horizontalImageBody">
            <img src={imgHANSAFLEX_Ireland_horizontal_homepage} alt="Irelandhorizontal" className="responsive-image" />
        </div>
    )
}

export default Horizontal